<interacta-dialog [isOpen]="isOpen()" [size]="dialogSize()" (closing)="close()">
    <h2 class="typo-t6" title>
        {{ 'SHARED.LICENSE_UPGRADE.TITLE' | translate }}
    </h2>

    <interacta-license-upgrade-panel
        content
        [canRequestUpgrade]="canRequestUpgrade()"
        [description]="descriptionKey() | translate: translationVars()"
        [isSending]="submitService.isSending()"
        [layout]="'dialog'"
        [noteMaxLength]="noteMaxLength"
        [showActions]="false"
        (send)="send($event)"
    />

    <interacta-dialog-buttons [showLoader]="submitService.isSending()">
        <!--
            Two blocks on the same condition rather than one: the button row
            projects `button[interacta-dialog-button]` and has no catch-all slot,
            so an @if holding both buttons at its root gets neither projected and
            the dialog loses its actions.
        -->
        @if (canRequestUpgrade()) {
            <button
                interacta-dialog-button
                type="button"
                [label]="'UI.BUTTON.CANCEL' | translate"
                [style]="'text'"
                (click)="close()"
            ></button>
        }
        @if (canRequestUpgrade()) {
            <button
                data-testid="license-upgrade-send"
                interacta-dialog-button
                type="button"
                [disabled]="!canSend()"
                [label]="'SHARED.LICENSE_UPGRADE.SEND' | translate"
                [style]="'filled'"
                (click)="submit()"
            ></button>
        } @else {
            <button
                interacta-dialog-button
                type="button"
                [label]="'SHARED.BUTTON.UNDERSTOOD' | translate"
                [style]="'filled'"
                (click)="close()"
            ></button>
        }
    </interacta-dialog-buttons>
</interacta-dialog>
